import { Button, FormControl } from "@mui/material";

import UploadIcon from "@mui/icons-material/Upload";

export interface IProps {
    accept: string;
    onChange?: any;
    selectedFile?: any;
    disabled?: boolean;
}

export default function FileInputButton(props: IProps) {
    let inputRef: any;
    let fileNameText = "Nenhum arquivo selecionado";

    if (props.selectedFile && props.selectedFile?.name !== "") {
        fileNameText = props.selectedFile.name;
    }

    return (
        <div>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
                <Button
                    variant="contained"
                    disabled={props.disabled}
                    startIcon={<UploadIcon />}
                    onClick={() => {
                        (document.getElementById("uploadCaptureInputFile") as HTMLInputElement).value = "";
                        inputRef.click();
                    }}
                >
                    Upload de Arquivo
                </Button>
                <input
                    type="file"
                    accept={props.accept}
                    onChange={props.onChange}
                    id="uploadCaptureInputFile"
                    hidden
                    ref={(refParam) => (inputRef = refParam)}
                    multiple={false}
                />
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
                <p>{fileNameText}</p>
            </FormControl>
        </div>
    );
}
